var _path, _circle, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgViewEntry(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 60,
    viewBox: "0 0 55 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.5 16.525L35 13L31.5 16.525L28 13L24.5 16.525L21 13L17.5 16.525L14 13L10.5 16.525L7 13L3.5 16.525L0 13V60L3.5 56.475L7 60L10.5 56.475L14 60L17.5 56.475L21 60L24.5 56.475L28 60L31.5 56.475L35 60L38.5 56.475L42 60V13L38.5 16.525ZM37.3333 53.1615H4.66667V19.8385H37.3333V53.1615ZM7 43.55H35V48.25H7V43.55ZM7 34.15H35V38.85H7V34.15ZM7 24.75H35V29.45H7V24.75Z",
    fill: "#023E7D"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    cy: 13,
    r: 13,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35 17.1483V20H37.8517L46.2624 11.5894L43.4106 8.73764L35 17.1483ZM49 8.85171L46.1483 6L44.2243 7.93156L47.076 10.7833L49 8.85171Z",
    fill: "#023E7D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewEntry);
export default __webpack_public_path__ + "static/media/viewEntry.266628287aaf3595dc88f01a7009ef03.svg";
export { ForwardRef as ReactComponent };